import type { FC, HTMLAttributes, PropsWithChildren } from 'react';

import { THEME_DATA_IDENTIFIER } from '@eneco/sparky/providers';
import { themeClassNames } from '@eneco/sparky/theme';

export const Body: FC<PropsWithChildren<HTMLAttributes<HTMLBodyElement>>> = ({ children, ...props }) => {
  const themeClass = themeClassNames['default'];

  return (
    <body className={themeClass} {...{ [`data-${THEME_DATA_IDENTIFIER}`]: themeClass }} {...props}>
      {children}
    </body>
  );
};
